module.exports = __webpack_public_path__ + "img/partner-1.3193c654.png";